<template>
    <modal :max_width="400" class="modal-message " @close="$emit('close')">
        <div v-if="this.text_action==='save'" class="mx-12 flex text-center justify-center i flex-col text-main-text text-sm">
            <p class="text-brand-light font-semibold">{{captain_name}}, <span class="text-main-text">изменения внесены.</span></p>
            <br>
          <p class="mb-10">Администратор свяжется с вами<br class="hidden lg:block"> для подтверждения информации.</p>
        </div>
        <div v-if="this.text_action==='paid'" class="mx-12 flex text-center flex-col">
            <p class="text-brand-light font-semibold">{{captain_name}}, <span class="text-main-text">ваша заявка отменена.</span></p>
            <br>
            <p class="mb-10">Ждём вас на следующих играх!</p>
        </div>
        <div v-if="this.text_action==='not_paid'" class="mx-12 flex text-center flex-col">
            <p class="text-brand-light font-semibold">{{captain_name}}, <span class="text-main-text">ваша заявка отменена.</span></p>
            <br>
            <p class="mb-10">Ждём вас на следующих играх!</p>
        </div>
        <div v-if="this.text_action==='restore_account'" class="mx-12 flex text-center flex-col">
            <p class="mt-2 font-normal text-center">На вашу почту отправлено <a class="text-brand-light font-bold no-underline">письмо</a>.</p>
        <br>
        <p class="font-normal text-center mb-8">Пройдите по ссылке в письме,
        чтобы восстановить доступ.</p>
        </div>
        <div v-if="this.text_action==='login'" class="mx-12 flex text-center flex-col">
            <p class="mt-2 font-normal text-center">На вашу почту отправлено <a class="text-brand-light font-bold no-underline">письмо</a>.</p>
        <br>
        <p class="font-normal text-center mb-10">Пройдите по ссылке в письме,
        чтобы авторизоваться.</p>
        </div>
    </modal>
</template>

<script>
import ModalMixin from '../../../mixins/modals.js';
import Modal from '@/views/modals/base-modal-white';

export default {
  name: 'TextModal',
  components: { Modal },
  props: {
    text_modal: {

    },
    text_action: {

    },
    captain_name: { default: 'Имя капитана' },
  },
  mixins: [ModalMixin],
  data() {
    return {
      ext: '',
      show: false,
      loaded: false,
      vale: this.text_action,
    };
  },

};

</script>

<style scoped>

.modal-message {
    width: 400px !important;
    min-width: 320px;
  }
  div{
       @apply text-main-text text-sm
  }
</style>
